angular.module('natgeo').controller('Level4BuildControllerScreen', ['$scope', '$element', 'ScreenFactory', 'screenManager', 'container', 'UserProgress', 'ScreenView', 'CommonFunctions',
function Level4BuildControllerScreen($scope, element, ScreenFactory, manager, container, UserProgress, ScreenView, CommonFunctions)
{
	var screen = ScreenFactory( 'level4_build_controller', element );
	
	screen.once('introBefore', function()
	{
		
	});

	// Clear previously selected parameters.
	screen.on('introBefore', function()
	{
		UserProgress.SubmarineController = null;
		screen.clearSelection();
		screen._next.addClass('hidden');

		$scope.$apply();
	});

	// Add submarine selection functions to $scope
	CommonFunctions.setupSubmarineFunctions($scope, UserProgress);

	// Displays the help modal with the given name
	$scope.help = CommonFunctions.help( screen, 'next' );
	
	screen.previousContainer = null;

	// Clears any selection.
	screen.clearSelection = function()
	{
		var prevContainer = screen.sprite( screen.previousContainer );

		if ( prevContainer )
		{
			prevContainer.stopIt();
			prevContainer.children('div').removeClass('back-blue').addClass('back-gray');
		}

		screen.previousContainer = null;
	};

	// Controller Selection
	$scope.setController = function(type, container)
	{
		UserProgress.SubmarineController = type;

		if ( screen.previousContainer !== container )
		{
			screen.clearSelection();

			var currContainer = screen.sprite( screen.previousContainer = container );

			currContainer.play( 'pulse infinite' );
			currContainer.children('div').removeClass('back-gray').addClass('back-blue');
		}

		if ( screen._next.hasClass('hidden') )
		{
			screen.introduce( 'next', 'nextIn' );
		}
	};

	// The next screen is the test screen
	$scope.next = function()
	{
		manager.transition('level4_test');
	};
	
	// The previous screen is the build sensor screen
	$scope.prev = function()
	{
		manager.transition('level4_build_effector');
	};
	
}]);